<header class="fx-row bg-grey-100 px-3 fx-justify-between pt-3 pb-1">
  <span class="tw-text-base tw-font-medium text-grey-400">
    {{ data.title }}
  </span>
  <button mat-dialog-close>
    <mat-icon class="text-grey-400">close</mat-icon>
  </button>
</header>

<mat-dialog-content>
  <div
    class="text-grey-400 tw-text-base tw-font-normal"
    [innerHTML]="data.content">
  </div>
</mat-dialog-content>
<mat-dialog-actions
  *ngIf="data.buttons.length"
  align="end">
  <button
    *ngFor="let button of data.buttons"
    mat-button
    class="text-grey-400"
    [ngClass]="button.cssClass"
    [mat-dialog-close]="button.closeDialogOnAction"
    [attr.cdkFocusInitial]="button.focus ? '' : null"
    (click)="button.action()">
    {{ button.text }}
  </button>
</mat-dialog-actions>
